import { Box, Stack, Spinner } from "@adfenix/alexandria";

const Loading = () => {
  return (
    <Stack spacing="xs" pY="xl5" pX="xl5">
      <Box display="flex" justifyContent="center">
        <Spinner />
      </Box>
    </Stack>
  );
};

export default Loading;
